import * as React from "react";
import DropDown from "components/DropDown";
import RadioSelector from "components/RadioSelector";
import { makeStyles, createStyles, TextField, Theme } from "@material-ui/core";
import config from "customConfig";

export interface ReadingControlProps {
  input: any;
  handleInputChange: any;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputContainer: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  })
);

const ReadingControl: React.FC<ReadingControlProps> = ({
  input,
  handleInputChange,
}) => {
  const classes = useStyles();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    handleInputChange("search")(value);
  };
  const readingPassageNumber =
    input.genre === "A"
      ? config.readingPassageNumberA
      : config.readingPassageNumberG;

  return (
    <div>
      <div className={classes.inputContainer}>
        <DropDown
          name="Format"
          options={config.readingTypeName}
          value={input.typeName}
          setValue={handleInputChange("typeName")}
        />
        <TextField
          label="Search by ID"
          type="search"
          variant="outlined"
          name="search"
          autoComplete="off"
          value={input.search ?? ""}
          onChange={handleChange}
          className={classes.formControl}
        />
      </div>
      <div className={classes.inputContainer}>
        <DropDown
          name="Book"
          options={config.books}
          value={input.book}
          setValue={handleInputChange("book")}
          noneValue
        />
        <RadioSelector
          name="Genre"
          options={config.genre}
          value={input.genre}
          setValue={handleInputChange("genre")}
        />
        {input.typeName === "ReadingPassage" && (
          <DropDown
            name="Type"
            options={config.readingTypeOptions}
            value={input.types}
            setValue={handleInputChange("types")}
            noneValue
          />
        )}
        {input.typeName === "ReadingQuestion" && (
          <DropDown
            name="Type"
            options={config.readingTypeOptions}
            value={input.type}
            setValue={handleInputChange("type")}
            noneValue
          />
        )}
        {input.typeName !== "ReadingTest" && (
          <DropDown
            name="Passage"
            options={readingPassageNumber}
            value={input.passageNumber}
            setValue={handleInputChange("passageNumber")}
            noneValue
          />
        )}
      </div>
    </div>
  );
};

export default ReadingControl;
